export function parseFile(elementUrl) {
   let id;
   let parts;
   if (elementUrl !== null && elementUrl !== undefined) {
      parts = elementUrl.split(
         //eslint-disable-next-line
         /^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/,
      );

      if (elementUrl.indexOf("?id=") >= 0) {
         id = parts[6].split("=")[1].replace("&usp", "");
         return id;
      } else {
         id = parts[5].split("/");
         let sortArr = id.sort((a, b) => {
            return b.length - a.length;
         });
         id = sortArr[0];
      }
   }

   return id;
}
